module.exports = __webpack_public_path__ + "media/yalobusha-review.95ccd804.mp4";